<template>
    <div class="page-title" @click="back">
        <i class="iconfont x-arrow-lift"></i>
        <h3>{{ title }}<template v-if="storePageTitle"> / {{ storePageTitle }}</template></h3>
    </div>
</template>
<script>

export default {
    data() {
        return {
            title: this.$route.meta.title,
        }
    },
    mounted() {
        this.$store.commit('setPageTitle', localStorage.getItem('pageTitle'));
    },
    methods: {
        back() {
            localStorage.removeItem('pageTitle');
            this.$router.go(-1);
        }
    },
    computed: {
        storePageTitle() {
            return this.$store.state.pageTitle;
        },
    }
}
</script>
<style lang="scss" scoped>
    .page-title {
        width: 80%;
        margin: 0 auto;
        padding: 40px 0;
        display: flex;
        align-items: center;
        font-size: 24px;
        line-height: 1;
        cursor: pointer;

        .iconfont {
            font-size: 40px;
        }
    }
</style>